import { defineComponent as _defineComponent } from 'vue'
import { KpiWidgetData } from '@/models/Charts/chartsData';
import KpiWidget from '../common/KpiWidget.vue';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { computed } from 'vue';
import {
  TrendData,
  getTrendDataFromPieWidgetData,
} from '@/components/bend/kpiWidgetUtils';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberOfBendsWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: KpiWidgetData[] | null;
  generator: ChartGenerator<KpiWidgetData>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const trendData = computed<TrendData | null>(() =>
  getTrendDataFromPieWidgetData(
    props.data,
    props.widgetDefinition.timeFilterEnumValue!,
  ),
);

return { __sfc: true,props, t, trendData, KpiWidget }
}

})